<template>
  <div class="mainbo" styule="width: 100%; height: 100%;display: block;">
    <div class="content-box">
      <el-tabs v-model="activeName" type="card">
        <div class="tab-content">
          <el-form :label-position="labelPosition" label-width="120px">
            <el-form-item label="id">
              <el-input v-model="model.cabinetCode" style="width: 200px" />
            </el-form-item>

            <el-form-item label="上传文件">
              <el-upload
                class="upload-demo"
                :limit="1"
                :action="uploadApi + '/cabinet/file/uploadFile/v2'"
                :headers="headers"
                :on-preview="handlePictureCardPreview"
                :on-exceed="handleExceed"
                :file-list="fileList"
                :on-success="handleSuccess"
                :on-remove="handleRemove"
              >
                <el-button
                  slot="trigger"
                  size="mini"
                  style="width: 120px"
                  type="primary"
                  >选取文件</el-button
                >
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
      </el-tabs>
    </div>
    <div
      class="footer-box"
      style="display: flex; justify-content: space-between; gap: 20px"
    >
      <div class="communication section" style="flex: 1">
        <div class="section-title">通信配置</div>
        <div
          class="name"
          style="
            display: flex;
            justify-content: space-around;
            margin-bottom: 10px;
          "
        >
          <div class="name-title" style="width: 100px">标签</div>
          <div class="name-title" style="width: 100px">通讯方式</div>
          <div class="name-title" style="flex: 1">地址</div>
        </div>
        <div
          class="device-item"
          v-for="(device, index) in scoJson.DeviceAccessPorts"
          :key="index"
          @click="openK(device)"
          style="cursor: pointer"
        >
          <div class="device-name" style="width: 120px">
            {{ device.Description }}
          </div>
          <div class="device-name" style="width: 70px">{{ device.Type }}</div>
          <div class="device-name" style="flex: 1">
            {{ displayValue(device) }}
          </div>
        </div>
      </div>
      <div class="energyStorage section" style="flex: 1">
        <div class="section-title">储能硬件</div>
        <div
          class="name"
          style="
            display: flex;
            justify-content: space-around;
            margin-bottom: 10px;
          "
        >
          <div class="name-title" style="width: 95px">硬件</div>
          <div class="name-title" style="width: 70px">数量</div>
          <div class="name-title" style="width: 80px">站地址</div>
          <div class="name-title" style="flex: 1">通讯方式</div>
        </div>
        <div
          class="device-item"
          v-for="(hardware, index) in energy"
          :key="index"
        >
          <div class="device-name" style="width: 100px">
            {{ hardware.Type.TagTxt }}
          </div>
          <div class="device-name" style="width: 70px">
            {{ hardware.DeviceCount }}
          </div>
          <div class="device-name" style="width: 70px">
            {{ hardware.SlaveAddress }}
          </div>
          <div class="device-name" style="flex: 1">
            {{ hardware.DeviceAccessPortIdentifier }}
          </div>
        </div>
      </div>
      <div class="relationship section" style="flex: 1">
        <div class="section-title">对应关系</div>
        <div
          class="device-item"
          v-for="(hardware, index) in scoJson.BatteryClusters"
          :key="index"
        >
          <div class="device-name3" style="widows: 30px">
            {{ hardware.Id }}簇
          </div>
          <div style="display: flex; flex-wrap: wrap; width: 40%">
            <div
              class="device-name3"
              v-for="(product, productId) in hardware.PcsModels"
              :key="productId + 99"
            >
              {{ product.TagTxt }}
            </div>
          </div>
          <div style="display: flex; flex-wrap: wrap; width: 40%">
            <div
              class="device-name3"
              v-for="(product, productId) in hardware.BmsModels"
              :key="productId + 199"
            >
              {{ product.TagTxt }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-box">
      <div class="footer-btn">
        <el-button type="primary" @click="submitForm()" :disabled="flag1"
          >上传</el-button
        >
        <el-button type="primary" @click="submitFormX()" :disabled="flag"
          >下载Source</el-button
        >
        <el-button type="primary" @click="submitFormY()" :disabled="flag"
          >导出配置</el-button
        >
      </div>
    </div>
    <!-- 弹窗组件 -->
    <el-dialog
      title="编辑串口/IP"
      :visible.sync="showEditDialog"
      width="500px"
      @close="handleClose"
    >
      <!-- 表单内容 -->
      <el-form ref="editFormRef" :model="editForm" label-width="100px">
        <!-- 标签输入框 -->
        <el-form-item label="标签" label-width="110px">
          <el-input v-model="editForm.Description" disabled></el-input>
        </el-form-item>

        <!-- 通讯方式下拉选择 -->
        <el-form-item label="通讯方式" label-width="110px">
          <el-input v-model="editForm.Type" disabled></el-input>
        </el-form-item>

        <!-- IP地址输入框 -->
        <el-form-item
          v-if="editForm.Type == 'TCP'"
          label="IP地址"
          label-width="110px"
        >
          <el-input v-model="editForm.Ip" disabled></el-input>
        </el-form-item>

        <!-- 端口号输入框 -->
        <el-form-item
          v-if="editForm.Type == 'TCP'"
          label="端口号"
          label-width="110px"
        >
          <el-input v-model="editForm.Port" disabled></el-input>
        </el-form-item>

        <el-form-item
          v-if="editForm.Type != 'TCP'"
          label="串口号"
          label-width="110px"
        >
          <el-input v-model="editForm.Com" disabled></el-input>
        </el-form-item>
        <el-form-item
          v-if="editForm.Type != 'TCP'"
          label="波特率"
          label-width="110px"
        >
          <el-input v-model="editForm.Baud" disabled></el-input>
        </el-form-item>

        <el-form-item
          v-if="editForm.Type != 'TCP'"
          label="校验位"
          label-width="110px"
        >
          <el-input v-model="editForm.ParityTag" disabled></el-input>
        </el-form-item>

        <el-form-item
          v-if="editForm.Type != 'TCP'"
          label="数据位"
          label-width="110px"
        >
          <el-input v-model="editForm.DataBits" disabled></el-input>
        </el-form-item>

        <el-form-item
          v-if="editForm.Type != 'TCP'"
          label="停止位"
          label-width="110px"
        >
          <el-input v-model="editForm.StopBits" disabled></el-input>
        </el-form-item>

        <!-- 读取超时输入框 -->
        <el-form-item label="读取超时(毫秒)" label-width="110px">
          <el-input v-model="editForm.ReadTimeout" disabled></el-input>
        </el-form-item>

        <!-- 写入超时输入框 -->
        <el-form-item label="写入超时(毫秒)" label-width="110px">
          <el-input v-model="editForm.WriteTimeout" disabled></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { AxiosAjax, uploadApi, baseApi } from "../../js/axios.config";
export default {
  data() {
    return {
      flag: true,
      flag1: true,
      dataP: {},
      fileList: [],
      uploadApi: uploadApi,
      headers: { Authorization: "" },
      activeName: "account", //当前选项卡
      labelPosition: "right", //表单对齐方式
      model: {
        cabinetCode: "",
      },
      systemList: [
        { companyName: "Windows", id: 1 },
        { companyName: "Android", id: 2 },
      ],
      scoJson: {},
      energy: [],
      // 控制弹窗显示/隐藏
      showEditDialog: false,
      editForm: {},
      // DeviceAccessPortConcise:{
      //   Description:"",
      //   Identifier:"",
      //   Type:"",
      //   Com:"",
      //   Baud:"",
      //   Parity:"",
      //   DataBits:"",
      //   StopBits:"",
      //   Ip:"",
      //   Port:"",
      //   ReadTimeout:"",
      //   WriteTimeout:""
      // },
      // deviceArcConfigConcise: {
      //   "DeviceAccessPorts":[],

      // },
    };
  },
  mounted() {
    this.headers.Authorization = localStorage.getItem("fx_client_access_token");
    this.model.cabinetCode = this.$route.query.cabinetCodes || "";
    this.getData();
  },
  computed: {
    displayValue() {
      return (value) => {
        if (value.Type === "COM") {
          return value.Com + ":" + value.Baud;
        } else if (value.Type === "SERIAL") {
          return value.Com + ":" + value.Baud;
        } else if (value.Type === "TCP") {
          return value.Ip + ":" + value.Port;
        }
      };
    },
  },
  methods: {
    handleClose() {
      this.showEditDialog = false;
      this.editForm = {};
    },
    openK(value) {
      this.showEditDialog = true;
      this.editForm = value;
    },
    filterBatteryClusters(data) {
      if (data.BatteryClusters && Array.isArray(data.BatteryClusters)) {
        data.BatteryClusters.forEach((cluster) => {
          // 过滤 PcsModels
          if (cluster.PcsModels && Array.isArray(cluster.PcsModels)) {
            cluster.PcsModels = cluster.PcsModels.filter(
              (item) => item.IsChecked === true
            );
          }

          // 过滤 BmsModels
          if (cluster.BmsModels && Array.isArray(cluster.BmsModels)) {
            cluster.BmsModels = cluster.BmsModels.filter(
              (item) => item.IsChecked === true
            );
          }
        });
      }
      return data;
    },
    convertToArray(obj) {
      const excludeKeys = [
        "IsInDesignMode",
        "BatteryClusters",
        "PcsBmsRel",
        "BmsPcsRel",
        "DeviceAccessPorts",
      ];
      const result = [];

      for (let key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] !== null) {
          // 排除指定的属性名
          if (excludeKeys.includes(key)) {
            continue;
          }

          // 递归清理对象内部的指定属性
          const cleanedItem = this.cleanObject(obj[key], excludeKeys);
          result.push(cleanedItem);
        }
      }

      return result;
    },
    cleanObject(obj, excludeKeys) {
      if (Array.isArray(obj)) {
        return obj.map((item) => this.cleanObject(item, excludeKeys));
      }

      if (obj !== null && typeof obj === "object") {
        const cleaned = {};
        for (let key in obj) {
          if (
            obj.hasOwnProperty(key) &&
            !excludeKeys.includes(key) &&
            obj[key] !== null
          ) {
            cleaned[key] = this.cleanObject(obj[key], excludeKeys);
          }
        }
        return cleaned;
      }

      return obj;
    },

    submitFormX() {
      let _this = this;
      const apiUrl = "cabinet" + this.dataP.relativePath;
      AxiosAjax({
        url: apiUrl,
        success: (res) => {
          console.log(res);
          // 1. 获取JSON数据
          const jsonData = res.data;

          // 2. 将JSON对象转为字符串（可选：格式化，缩进2个空格）
          const jsonString = JSON.stringify(jsonData, null, 2);

          // 3. 创建Blob对象（指定文件类型为JSON）
          const blob = new Blob([jsonString], { type: "application/json" });

          // 4. 生成下载链接
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = _this.dataP.fileName; // 自定义文件名（可从API响应头获取）
          document.body.appendChild(link);
          link.click();

          // 5. 清理资源
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        },
      });
    },

    getConciseData(fullData) {
      // 1. 辅助函数：处理端口列表
      // 对应 C# 类: DeviceAccessPortConcise
      const mapPort = (p) => {
        if (!p) return null;
        return {
          Description: p.Description,
          Identifier: p.Identifier,
          Type: p.Type,
          Com: p.Com,
          Baud: p.Baud,
          Parity: p.Parity,
          DataBits: p.DataBits,
          StopBits: p.StopBits,
          Ip: p.Ip,
          Port: p.Port,
          ReadTimeout: p.ReadTimeout,
          WriteTimeout: p.WriteTimeout,
          // 注意：丢弃了 ConnectType, IsEdit, Ico 等字段
        };
      };

      // 2. 辅助函数：处理设备属性
      // 对应 C# 类: ComPropertyConcise
      const mapComProperty = (prop) => {
        if (!prop) return null;
        return {
          DeviceAccessPortIdentifier: prop.DeviceAccessPortIdentifier,
          SlaveAddress: prop.SlaveAddress,
          Model: prop.Model,
          DeviceCount: prop.DeviceCount,
          // 注意：丢弃了 DeviceAccessPort 完整对象, Type, IsEdit 等
        };
      };

      // 3. 构建精简对象
      // 对应 C# 类: DeviceArcConfigConcise
      const conciseData = {
        // 处理端口列表
        DeviceAccessPorts: fullData.DeviceAccessPorts
          ? fullData.DeviceAccessPorts.map(mapPort)
          : [],

        // 处理各类设备属性 (类型为 ComPropertyConcise)
        BmsProperty: mapComProperty(fullData.BmsProperty),
        PcsProperty: mapComProperty(fullData.PcsProperty),
        StsProperty: mapComProperty(fullData.StsProperty),
        HnPcsProperty: fullData.HnPcsProperty,
        UserSideAmmeterProperty: mapComProperty(
          fullData.UserSideAmmeterProperty
        ),
        UserSideAmmeter2Property: fullData.UserSideAmmeter2Property,
        DeviceSideAmmeterProperty: mapComProperty(
          fullData.DeviceSideAmmeterProperty
        ),
        AirCondProperty: mapComProperty(fullData.AirCondProperty),
        FireControlProperty: mapComProperty(fullData.FireControlProperty),
        IOModuleControlProperty: mapComProperty(
          fullData.IOModuleControlProperty
        ),

        // 处理字典
        PcsBmsRel: fullData.PcsBmsRel,

        // 注意：BatteryClusters 在 C# DeviceArcConfigConcise 类中没有定义，所以这里不包含它
      };

      return conciseData;
    },

    submitFormY() {
      let _this = this;
      const apiUrl = "cabinet" + this.dataP.relativePath;

      AxiosAjax({
        url: apiUrl,
        success: (res) => {
          // 1. 获取JSON数据
          const jsonData = _this.getConciseData(res.data);
          // 2. 将JSON对象转为字符串（可选：格式化，缩进2个空格）
          const jsonString = JSON.stringify(jsonData, null, 2);
          // 3. 创建Blob对象（指定文件类型为JSON）
          const blob = new Blob([jsonString], { type: "application/json" });
          // 4. 生成下载链接
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "DeviceArcConfig.json"; // 自定义文件名（可从API响应头获取）
          document.body.appendChild(link);
          link.click();
          // 5. 清理资源
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        },
      });
    },

    getData() {
      let _this = this;
      AxiosAjax({
        url:
          "/cabinet/cabinetConfig/latest?cabinetCode=" + this.model.cabinetCode,
        success: (res) => {
          _this.dataP = res.data.data;

          if (_this.dataP.relativePath != null) {
            _this.flag = false;
            _this.getJsonData();
          }
        },
      });
    },
    getJsonData() {
      let _this = this;
      const apiUrl = "cabinet" + this.dataP.relativePath;
      AxiosAjax({
        url: apiUrl,
        success: (res) => {
          // 1. 获取JSON数据
          _this.energy = _this.convertToArray(res.data);

          _this.scoJson = _this.filterBatteryClusters(res.data);
        },
      });
    },
    handleExceed() {
      this.$message.warning("最多选择一个文件，如需修改请删除在面文件！");
    },
    handleSuccess(file, fileList) {
      this.model = file.data;
      this.fileList.push({
        name: file.data.relativePath,
        url: file.data.relativePath,
      });
      this.model.cabinetCode = this.$route.query.cabinetCodes || "";
      this.flag1 = false;
    },
    handleRemove(file, fileList) {
      console.log(fileList);
      this.fileList = [];
    },
    handlePictureCardPreview(file) {},
    submitForm: function () {
      let _this = this; //当前页面
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinetConfig/save",
        data: _this.model,
        loading: true,
        successMsg: "上传成功",
        success: function (res) {
          _this.getData();
        },
      });
    },
    resetForm() {
      window.history.back(-1);
    },
  },
};
</script>
<style scoped>
.el-form-item /deep/ .el-form-item__content {
  text-align: left;
}
.device-item {
  display: flex;
  justify-content: space-around;
}

.footer-box {
  width: 100%;
}
.section-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #303133;
}
.section {
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
  height: 260px;
  overflow-y: auto; /* 垂直方向滚动 */
}
.device-name {
  padding: 8px 0px;
}
.el-dialog__wrapper /deep/ .el-dialog {
  border-radius: 12px; /* 弹窗圆角，可根据需求调整数值 */
}
</style>


// WEBPACK FOOTER //
// src/components/Monitor/ConfigAdd.vue